'use client';

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { StyledActionGroup } from './elements';
export const ActionGroup = ({
  alignment = 'left',
  direction = 'row',
  ...rest
}) => /*#__PURE__*/React.createElement(StyledActionGroup, _extends({
  "data-aui": "action-group",
  $alignment: alignment,
  $direction: direction
}, rest));